import { useBlocker } from 'react-router-dom'

export function useUnsavedChangesWarning(shouldBlock: boolean) {
	const blocker = useBlocker(
		({ currentLocation, nextLocation }) => shouldBlock && currentLocation.pathname !== nextLocation.pathname,
	)

	return {
		isBlocked: blocker.state === 'blocked',
		confirmLeave: () => blocker.proceed?.(),
		cancelLeave: () => blocker.reset?.(),
	}
}
